import { render, staticRenderFns } from "./gridgroup.vue?vue&type=template&id=fa868f7a&scoped=true&"
import script from "./gridgroup.vue?vue&type=script&lang=js&"
export * from "./gridgroup.vue?vue&type=script&lang=js&"
import style0 from "./gridgroup.vue?vue&type=style&index=0&id=fa868f7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa868f7a",
  null
  
)

export default component.exports